export default "__VITE_ASSET__CyA$7B8e__"